const filterEmptyRecursive = <T extends Array<any>>(
    array: T | undefined
): Array<any> => {
    if (!array) {
        return [];
    }

    return array.filter((x) => {
        if (Array.isArray(x)) {
            return filterEmptyRecursive(x).length > 0;
        }

        return !!x;
    });
};

export default filterEmptyRecursive;
